import Store from 'redux/store';
import {
  LIST_REGULATION,
  LIST_REGULATION_FAIL,
  LIST_REGULATION_SUCCESS,
} from 'redux/Reducers/Regulation/RegulationReducer';
import { cloudloyalty } from '../clients';

/* eslint-disable */
export const FetchRegulationCampaign = async (
  User,
  finallyCallback = () => {},
  { campaignId, catalogId }
) => {
  Store.dispatch({ type: LIST_REGULATION, payload: { campaignId, catalogId } });
  cloudloyalty(User)
    .get(
      `/v2/campaigns/regulations?campaignId=${campaignId}&catalogId=${catalogId}`
    )
    .then((response) => {
      Store.dispatch({
        type: LIST_REGULATION_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: LIST_REGULATION_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchRegulationsVendor = async (
  User,
  finallyCallback = () => {},
  { campaignId, catalogId, vendorId }
) => {
  Store.dispatch({
    type: LIST_REGULATION,
    payload: {
      campaignId,
      catalogId,
      vendorId,
    },
  });
  cloudloyalty(User)
    .get(
      `/v2/campaigns/regulations/store?catalogId=${catalogId}&vendorId=${vendorId}`
    )
    .then((response) => {
      Store.dispatch({
        type: LIST_REGULATION_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: LIST_REGULATION_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchRegulationsVendorAndRegulationType = async (
  User,
  finallyCallback = () => {},
  { campaignId, catalogId, vendorId, regulationType }
) => {
  Store.dispatch({
    type: LIST_REGULATION,
    payload: { campaignId, catalogId, vendorId, regulationType },
  });
  cloudloyalty(User)
    .get(`/v1/configurations/regulations/vendor/${vendorId}/${regulationType}`)
    .then((response) => {
      Store.dispatch({
        type: LIST_REGULATION_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: LIST_REGULATION_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
